import BaseAPI from "../api";

const path: string = "roles";
const app_path: string = "app-roles";

export interface rolesType {
  keyword?: string;
  page?: number;
  limit?: number;
  sortBy?: string;
  sortType?: string;
}
export interface rolesTypeProps {
  roleName: string;
  roleStatus: string;
  permission: any;
}

export class RolesApi extends BaseAPI {
  public static getRoles(props: rolesType): Promise<any> {
    return this.api
      .get(`${app_path}`, { params: { ...props } })
      .then((res) => res);
  }
  public static createRoles(props: rolesTypeProps): Promise<any> {
    return this.api.post(`${app_path}`, props).then((res) => res);
  }
  public static changeRoles(
    roleId: number,
    props: rolesTypeProps
  ): Promise<any> {
    return this.api.patch(`${app_path}/${roleId}`, props).then((res) => res);
  }
  public static getDetail(roleId: number): Promise<any> {
    return this.api.get(`${app_path}/${roleId}`).then((res) => res);
  }

  static getAllRoles(props: any): Promise<any> {
    return this.api.get(`${path}`, { params: { ...props } }).then((res) => res);
  }
  static getRole(props: any): Promise<any> {
    return this.api.get(`${path}/${props.idRole}`, {}).then((res) => res);
  }
}
